class RESTApiMapperEntityError extends Error {}

export default RESTApiMapperEntityError;
